import { initializeDB } from '../config/db';
import { PACKING_SLIP_STORE } from '../config/constants';
import axiosInstance from '../axiosInstance';

const packingSlipService = {
    async save(packingSlip) {
        const db = await initializeDB();
        const tx = db.transaction(PACKING_SLIP_STORE, 'readwrite');
        const store = tx.objectStore(PACKING_SLIP_STORE);
        await store.put(packingSlip);
        await tx.done;
        return packingSlip;
    },

    async loadByUuid(uuid) {
        const db = await initializeDB();
        const tx = db.transaction(PACKING_SLIP_STORE, 'readonly');
        const store = tx.objectStore(PACKING_SLIP_STORE);
        return await store.get(uuid);
    },

    async getAll() {
        const db = await initializeDB();
        const tx = db.transaction(PACKING_SLIP_STORE, 'readonly');
        const store = tx.objectStore(PACKING_SLIP_STORE);
        return await store.getAll();
    },

    async deleteFromIndexedDB(uuid) {
        const db = await initializeDB();
        const tx = db.transaction(PACKING_SLIP_STORE, 'readwrite');
        const store = tx.objectStore(PACKING_SLIP_STORE);
        await store.delete(uuid);
        await tx.done;
    },

    async submit(packingSlip) {
        try {
            const response = await axiosInstance.post('/packing-slip/submit', packingSlip);
            return response.data;
        } catch (error) {
            console.error('Error submitting packing slip:', error);
            throw error;
        }
    }
};

export default packingSlipService;
